import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCatcha = async (token) => {
    console.log("formData_feeeee", token);
    console.log("api_url",API_URL);
    try {
        const response = await axios.post(`${API_URL}/api/validate-captcha`, { captcha: token });

        return response;


    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }


};

export const fetchCrearCurso = async (newData) => {
    console.log("formData_feeeee", newData);
    try {
        const response = await axios.post(`${API_URL}/api/email/data`, newData, {

            headers: {
                'Content-Type': 'multipart/form-data'
            }

        });


        return response;

    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }


};

